import { ReactNode, useEffect, useState } from 'react'

import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import clsx from 'clsx'
import { observer } from 'mobx-react-lite'

import { RoutingPaths } from 'app/routes/routes'

import { DefaultGuests, kyrgyzstanSearchStore } from 'entities/kyrgyzstan/model'

import { AllIcons } from 'shared/ui/app-icon/types'
import { Button } from 'shared/ui/button'
import { ButtonIconTextWithLabel } from 'shared/ui/button-icon-text-with-label'
import { Paper } from 'shared/ui/paper'

import s from './styles.module.scss'

interface SearchFormKyrgyzstanProps {
  action?: ReactNode
  onSearch?: () => void
}

export const SearchFormKyrgyzstan = observer(
  ({ action, onSearch }: SearchFormKyrgyzstanProps) => {
    const { t } = useTranslation()
    const navigate = useNavigate()

    const {
      destinationDisplay,
      datesDisplay,
      guestsCount,
      cities,
      start_date,
      end_date,
      guestsDisplay,
      guests,
    } = kyrgyzstanSearchStore

    const [fieldErrors, setFieldErrors] = useState({
      destination: false,
      dates: false,
      guests: false,
    })

    useEffect(() => {
      if (!guests) {
        kyrgyzstanSearchStore.setGuests(DefaultGuests)
      }
    }, [cities, guests])

    const handleSearch = () => {
      const isDestinationEmpty = cities.length === 0
      const isDatesEmpty = !start_date || !end_date
      const isGuestsEmpty = guestsCount === undefined || guestsCount === 0

      const errors = {
        destination: isDestinationEmpty,
        dates: isDatesEmpty,
        guests: isGuestsEmpty,
      }

      setFieldErrors(errors)

      if (!isDestinationEmpty && !isDatesEmpty && !isGuestsEmpty) {
        onSearch?.()
      }
    }

    const handleCalendar = () => {
      navigate(RoutingPaths.kyrgyzstan.calendar.path())
    }

    const handleSelectGuests = () => {
      navigate(RoutingPaths.kyrgyzstan.selectGuests.path())
    }

    const handleSelectDestination = () => {
      navigate(RoutingPaths.kyrgyzstan.searchDirection.path())
    }

    return (
      <Paper
        padding={[16]}
        radius={'28px'}
      >
        {/* <div className={s.header}>
          <h2 className={clsx(s.title, 'extra-bold-24')}>
            {t('kyrgyzstan_block.search_form.title')}
          </h2>
          <p className={clsx(s.subtitle, 'medium-14')}>
            {t('kyrgyzstan_block.search_form.subtitle')}
          </p>
        </div> */}

        <div className={s.form}>
          <div className={s.field}>
            <ButtonIconTextWithLabel
              isEllipsis
              type="grey"
              height="auto"
              value={destinationDisplay}
              placeholder={t('kyrgyzstan_block.search_form.destination')}
              error={fieldErrors.destination}
              onClick={handleSelectDestination}
            />
            {/* <p className={clsx(s.hint, 'medium-12')}>
              {t('kyrgyzstan_block.search_form.destination_hint')}
            </p> */}
          </div>

          <div className={s.field}>
            <ButtonIconTextWithLabel
              type="grey"
              height="auto"
              value={datesDisplay}
              placeholder={t('kyrgyzstan_block.search_form.dates')}
              rightIcon={AllIcons.CALENDAR_NEW}
              error={fieldErrors.dates}
              onClick={handleCalendar}
            />
          </div>

          <div className={s.field}>
            <ButtonIconTextWithLabel
              placeholder={t('kyrgyzstan_block.search_form.guests')}
              value={guestsDisplay}
              rightIcon={AllIcons.PEOPLE_NEW_INPUT}
              type="grey"
              height="auto"
              error={fieldErrors.guests}
              onClick={handleSelectGuests}
            />
          </div>

          <Button
            className={clsx(s.searchButton, 'semi-bold-16')}
            onClick={handleSearch}
            borderRadius="md"
          >
            {t('kyrgyzstan_block.search_form.find_button')}
          </Button>

          {action}
        </div>
      </Paper>
    )
  },
)
